import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import { titleCase } from 'src/utils/stringFormatting';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { calculatePercentChange, formatMetric } from 'src/utils/app';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import { useEntityPhrasing } from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { useTaxonomySubtitleText } from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useMainTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';
import { ENTITY_PHRASES } from 'src/utils/constants';

const AtlasV2OrganicTrafficV2OrganicTrafficSplineChart = () => {
  const entityPhrase = useEntityPhrasing();
  const taxonomyText = useTaxonomySubtitleText();
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonTimePeriodShortDisplayName = useComparisonTimePeriodShortDisplayName();

  return (
    <AtlasV2DorisSplineChart
      queryKey="organicTrafficSplineChart"
      title="Organic Traffic"
      metricTypeDisplay={METRICTYPE.VOLUME}
      metricType="organicClicks"
      beaconChartWithLegendOverride={(props, metric) => {
        const { formattedPercentChange, primaryTotal, secondaryTotal } = metric;

        const formattedClicks = formatMetric(primaryTotal, METRICTYPE.VOLUME, {
          showFullValue: false,
          decimalPlaces: 1
        });
        const percentChange = calculatePercentChange(primaryTotal, secondaryTotal);
        const percentDirection = percentChange >= 0 ? 'higher' : 'lower';

        return {
          ...props,
          includeSummaryInfo: false,
          loadingComponent: <SplineChartLoading includeSubtitle />,
          subtitle: (
            <BeaconSubtitleContainer>
              <Text variant="body1" lineHeight="24px">
                {`${titleCase(entityPhrase, [...ENTITY_PHRASES])} earned ${formattedClicks} organic traffic `}
                {taxonomyText}
                {` during the ${mainTimePeriodShortDisplayName} period, which is ${formattedPercentChange} ${percentDirection} compared to the ${comparisonTimePeriodShortDisplayName}.`}
                <SubtitleFilters showFilterNumber={false} />
              </Text>
            </BeaconSubtitleContainer>
          )
        };
      }}
    />
  );
};
export default AtlasV2OrganicTrafficV2OrganicTrafficSplineChart;
